// User
export const FETCH_USER = 'FETCH_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

// Project
export const FETCH_PROJECT = 'FETCH_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';

// Schoolclass
export const UPDATE_SCHOOLCLASS = 'UPDATE_SCHOOLCLASS';
export const SET_GROUP_ID = 'SET_GROUP_ID';
export const ADD_SCHOOLCLASS_VIDEO = 'ADD_SCHOOLCLASS_VIDEO';
export const REMOVE_SCHOOLCLASS_VIDEO = 'REMOVE_SCHOOLCLASS_VIDEO';
export const ADD_SCHOOLCLASS_PHOTO = 'ADD_SCHOOLCLASS_PHOTO';
export const REMOVE_SCHOOLCLASS_PHOTO = 'REMOVE_SCHOOLCLASS_PHOTO';
export const SET_TIMER = 'SET_TIMER';


// Group
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const UPDATE_GHETTORADIO_GROUPS = 'UPDATE_GHETTORADIO_GROUPS';
export const UPDATE_GHETTORADIO_TIMER = 'UPDATE_GHETTORADIO_TIMER';
export const UPDATE_GHETTORADIO_LOCKED = 'UPDATE_GHETTORADIO_LOCKED';
export const UPDATE_GHETTORADIO_HANDLING_ACTION = 'UPDATE_GHETTORADIO_HANDLING_ACTION';
export const UPDATE_GHETTORADIO_ACTIVE = 'UPDATE_GHETTORADIO_ACTIVE';

// GameState
export const UPDATE_GAMESTATE = 'UPDATE_GAMESTATE';
export const UPDATE_GAMESTATE_SWITCH_ACTIVE = 'UPDATE_GAMESTATE_SWITCH_ACTIVE';
export const SET_STEP = 'SET_STEP';
export const SET_ROUND_STATE = 'SET_ROUND_STATE';
export const FINISHED_STEP = 'FINISHED_STEP';
export const UPDATE_HANDLING_ROUND_STATE_CHANGE = 'UPDATE_HANDLING_ROUND_STATE_CHANGE';

// Feedback
export const FETCH_FEEDBACK = 'FETCH_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const SET_ROUND = 'SET_ROUND';
export const UPDATE_FEEDBACK_READ = 'UPDATE_FEEDBACK_READ';

// GameStateInput
export const UPDATE_INPUT_STATES = 'UPDATE_INPUT_STATES';
export const UPDATE_MY_STATE = 'UPDATE_MY_STATE';
export const SUBMIT_MY_STATE = 'SUBMIT_MY_STATE';

// Popup
export const UPDATE_POPUP = 'UPDATE_POPUP';

// bankNotifications
export const UPDATE_BANKNOTIFICATION = 'UPDATE_BANKNOTIFICATION';


export const UPDATE_POLICY_CHOICE_OPTIONS = 'UPDATE_POLICY_CHOICE_OPTIONS';

export const UPDATE_TIMER = 'UPDATE_TIMER';

export const SET_REMOVED_CURRENT_ROUND = 'SET_REMOVED_CURRENT_ROUND';

export const FORCE_LANGUAGE = 'FORCE_LANGUAGE';

export default {
  FETCH_USER,
  UPDATE_USER,
  LOGOUT_USER,
  FETCH_PROJECT,
  UPDATE_PROJECT,
  UPDATE_SCHOOLCLASS,
  ADD_SCHOOLCLASS_VIDEO,
  REMOVE_SCHOOLCLASS_VIDEO,
  ADD_SCHOOLCLASS_PHOTO,
  REMOVE_SCHOOLCLASS_PHOTO,
  SET_GROUP_ID,
  UPDATE_GROUP,
  UPDATE_GHETTORADIO_GROUPS,
  UPDATE_GHETTORADIO_TIMER,
  UPDATE_GHETTORADIO_LOCKED,
  UPDATE_GAMESTATE,
  UPDATE_GAMESTATE_SWITCH_ACTIVE,
  SET_STEP,
  SET_ROUND_STATE,
  SET_TIMER,
  FETCH_FEEDBACK,
  UPDATE_FEEDBACK,
  UPDATE_FEEDBACK_READ,
  SET_ROUND,
  UPDATE_INPUT_STATES,
  UPDATE_MY_STATE,
  SUBMIT_MY_STATE,
  UPDATE_POPUP,
  UPDATE_POLICY_CHOICE_OPTIONS,
  FINISHED_STEP,
  UPDATE_BANKNOTIFICATION,
  UPDATE_TIMER,
  SET_REMOVED_CURRENT_ROUND,
  UPDATE_GHETTORADIO_HANDLING_ACTION,
  UPDATE_GHETTORADIO_ACTIVE,
  UPDATE_HANDLING_ROUND_STATE_CHANGE,
  FORCE_LANGUAGE,
};



// WEBPACK FOOTER //
// ./src/actions/types.js